<template>
  <BaseCard
    v-bind="$attrs"
    v-on="$listeners"
    :styleConfig="styleConfig"
  >
    <slot />
  </BaseCard>
</template>

<script>
  import BaseCard from '@base/v2/base-card'
  import { mapGetters } from 'vuex'

  export default {
    name: 'CardAction',
    inheritAttrs: false,
    components: {
      BaseCard,
    },
    data: function () {
      return {
        styleConfig: {
          container: {},
        },
      };
    },
    created: function () {
      Object.assign(
        this.styleConfig.container,
        {
          backgroundColor: this.color.shadow1(),
          border: `solid ${this.color.dark5()}`,
          borderWidth: '1px',
        },
      );
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
    },
  };
</script>
